/*
 * An always-visible version stamp in the bottom-left corner, over the sidebar's dark footer.
 *
 * Rendered through AppRootElementBlueprint (the same extension point the Guide dock and the
 * global-CSS injector use), so it persists across every route and needs no page to host it. It is
 * `pointer-events: none`, so it can never intercept a click on whatever is behind it, and small
 * and muted so it stays inconspicuous. Its whole job is to let a person — or a session verifying a
 * deploy — read at a glance whether the bundle in front of them is the one just shipped. See
 * version.ts and the CLAUDE.md rule that mandates the bump.
 */
import { AppRootElementBlueprint } from '@backstage/frontend-plugin-api';
import { VIEWER_VERSION } from './version';

const VersionBadge = () => (
  <div
    aria-hidden
    style={{
      position: 'fixed',
      // Just clear of the sidebar's right edge (expanded width ~224px), not inside it — the
      // sidebar's bottom-left is fully occupied by the Settings row, which the stamp was
      // overlapping. This puts it in the bottom-left of the content area, where nothing sits.
      left: 236,
      bottom: 10,
      // Above the sidebar (core-components draws it at z-index ~1000) with room to spare.
      zIndex: 2000,
      pointerEvents: 'none',
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
      fontSize: 10.5,
      lineHeight: 1,
      letterSpacing: '0.4px',
      // A SOLID pill, so the stamp is legible whatever is behind it — the dark sidebar or a light
      // page. An earlier translucent version vanished into the navy footer; this cannot.
      color: 'rgba(255, 255, 255, 0.85)',
      padding: '3px 8px',
      borderRadius: 6,
      background: 'rgba(0, 0, 0, 0.42)',
      border: '1px solid rgba(255, 255, 255, 0.18)',
      boxShadow: '0 1px 4px rgba(0, 0, 0, 0.4)',
    }}
  >
    v{VIEWER_VERSION}
  </div>
);

export const viewerVersionBadge = AppRootElementBlueprint.make({
  name: 'stackschematic-version-badge',
  params: { element: <VersionBadge /> },
});
